const courses = [
  {
    title: 'Computer Network Architecture',
    number: 'CS 356',
    link: '',
    university: 'Duke University',
  },
  {
    title: 'Algorithms and Databases',
    number: 'CS 310',
    link: '',
    university: 'Duke University',
  },
  {
    title: 'Design and Analysis of Algorithms',
    number: 'CS 308',
    link: '',
    university: 'Duke University',
  },
  {
    title: 'Operating Systems',
    number: 'CS 306',
    link: '',
    university: 'Duke University',
  },
  {
    title: 'Image Processing Data Science',
    number: 'CS 207',
    link: '',
    university: 'Duke University',
  },
  {
    title: 'Computer Programming and Design',
    number: 'CS 205',
    link: '',
    university: 'Duke University',
  },
];

export default courses;
